// import external dependencies
import 'jquery'

// Import everything from autoload


// Library
import './lib/touch-menu'
import './lib/carousels'
import './lib/home-hero-carousel'
import './lib/accordions'
import './lib/contact-map/contact-map'
import './lib/scroll-magic'
import './lib/little-widgets/little-widgets'
import GLightbox from 'glightbox'
import 'slick-carousel/slick/slick.min'

// Vue
import Vue from 'vue'
import SocialShare from './components/SocialShare.vue'

if (document.querySelector('.vue-social-share')) {
  new Vue({
      el: '.vue-social-share',
      components: {
        SocialShare
      }
    }
  )
}

// Header pop out navigation guide was found here
// https://codyhouse.co/gem/full-screen-pop-out-navigation/
$(window).on('scroll',
  {
    previousTop: 0
  },
  function () {
    var currentTop = $(window).scrollTop()
    let $mainNavigation = $('header.banner')

    //check if user is scrolling up
    if (currentTop < this.previousTop) {
      //if scrolling up...
      //add class 'is-visible' to the main navigation
      //if currentTop == 0, remove 'is-fixed' and 'is-visible' classes
      $mainNavigation.addClass('is-visible')

      if (currentTop <= 148) {

        $mainNavigation.removeClass('is-visible')
        $mainNavigation.removeClass('is-fixed')

      }

    } else {
      //if scrolling down...
      //add the 'is-fixed' class to the main navigation as soon as it is no longer visible
      //add class 'is-visible' to the main navigation

      if (currentTop > 148) {
        $mainNavigation.addClass('is-fixed')
      }
      $mainNavigation.removeClass('is-visible')

    }
    //set previousTop for the next iteration
    this.previousTop = currentTop
  }
)

// Load lighbox for lightbox video playback
var lightbox = GLightbox({
  plyr: {
    css: 'https://cdn.plyr.io/3.5.10/plyr.css', // Default not required to include
    js: 'https://cdn.plyr.io/3.5.10/plyr.js', // Default not required to include
    config: {
        muted: false,
        hideControls: true,
    },
    ratio: '16:9',
}
});

$('.carousel__people').slick({
  slidesToShow: 4,
  centerMode: false,
  dots: true,
  appendDots: $('.carousel__people__navigation'),
  responsive: [
    {
      breakpoint: 960,
      settings: {
        slidesToShow: 3
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 3
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1
      }
    }
  ]
});

// Scroll to a section of the page
window.onload = function () {
  
  var $fragment = window.location.hash.substr(1);

  if($fragment !== '') {
    var $elementId = $('#' + $fragment);
    
    $('body, html').animate({
      scrollTop: $elementId.offset().top - 100
    },
    400,
    'linear');

  }
  
}

// Confirm Mailchimp form submission
if(window.mc != null) {
  window.mc.ajaxOptions.complete = function() {
  
    // Check success message visibility 
    // and redirect user to thank you page
    if($('#mce-success-response').attr('style') == 'display: block;') {
      window.location = '/thank-you-for-subscribing/';
    }
    
  };
}



// WEBPACK FOOTER //
// ./scripts/main.js